import { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { BaseGatewayImage } from "@app/utils/apiUrl";

const useSignalR = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${BaseGatewayImage}/notificationHub`)
      .withAutomaticReconnect()
      .build();

    connection.start()
      .then(() => console.log("SignalR Connected"))
      .catch(err => console.error("SignalR Connection Error:", err));

    connection.on("ReceiveNotification", (data) => {
      console.log("Notification received:", data);
      setMessage("");
      setMessage(data);
      showDesktopNotification(data);
    });

    return () => {
      connection.stop();
    };
  }, []);

  const showDesktopNotification = (message) => {
    if (Notification.permission === "granted") {
      const notification = new Notification("📩 Thông báo mới", {
        body: message,
        icon: "https://cdn-icons-png.flaticon.com/512/1827/1827341.png", // Đường dẫn icon
      });

      // ✅ Phát âm thanh khi có thông báo
      const audio = new Audio("/notification.mp3"); // Đường dẫn file mp3
      audio.play();

      notification.onclick = () => {
        window.focus(); // Khi bấm vào thông báo sẽ mở ứng dụng
      };
    }
  };

  return message;
};

export default useSignalR;